// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"RecruitSideSetting_modal-scroll__IEhY1","side-setting-container":"RecruitSideSetting_side-setting-container___7iua"};